/**
 * Chrome/Vite throw this TypeError when a dynamic `import()` (or
 * modulepreload) fails to download — flaky network, a service-worker
 * intercept, or a stale hashed chunk after deploy.
 *
 * On the customer app these imports are vendor/PWA chunks (framer-motion
 * `domMax`, HeroUI motion wrappers, workbox-window), not route code. The
 * page has typically already rendered; the failure is not an application
 * logic bug and is not actionable in Sentry.
 */
export function isDynamicImportFetchError(error: unknown): boolean {
  if (!(error instanceof TypeError)) {
    return false;
  }

  return error.message.includes('Failed to fetch dynamically imported module');
}
